import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

/**
 * This hook is used to control the state that can be overwritten when a prop changes.
 */
const usePropControlledState = <T>(
    prop: T
): [T, Dispatch<SetStateAction<T>>] => {
    const lastProp = useRef(prop);
    const [state, setState] = useState(prop);

    useEffect(() => {
        if (prop === lastProp.current) {
            return;
        }

        lastProp.current = prop;

        if (prop === state) {
            return;
        }

        setState(prop);
    }, [prop]);

    return [state, setState];
};

export default usePropControlledState;
